// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_v05","cls2":"LoswpExitIntentModal-cls2_daN LoswpExitIntentModal-cls1_v05"};